import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const handToolsInsiderStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white tablet:bg-[#F4F4F5]',
  COMMONS_APPBAR_BG: 'bg-[#252525]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#252525]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#F04A24] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#FAEED6]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#F04A24]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#F04A24] hover:border-[#F04A24] hover:bg-[#F04A24] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#F04A24]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#252525]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#252525]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#FFD6B0]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#FFD6B0]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#F04A24] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#F04A24] text-[#F04A24] [&>svg>path]:stroke-[#F04A24] [&>svg>g>path]:stroke-[#F04A24] [&>svg>path]:fill-[#F04A24] [&>svg>g>path]:fill-[#F04A24]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#F04A24]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#252525]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#FAEED6]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#FFD6B0]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#FAEED6]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#252525] [&>.explore-icon-fill]:!fill-[#FAEED6] [&>g>.explore-icon-fill]:!fill-[#FAEED6]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FAEED6] [&>.vector-top>path]:fill-[#252525] [&>.vector-bottom>path]:fill-[#252525]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#6C5440]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FAEED6]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#3F3F46]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#8F6C4D]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#8F6C4D]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#FFD6B0]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#BD4124]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#BD4124]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#BD4124]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-white',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#030303]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#F04A24] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#F04A24] text-[#F04A24] [&>svg>path]:stroke-[#F04A24] [&>svg>g>path]:stroke-[#F04A24] [&>svg>path]:fill-[#F04A24] [&>svg>g>path]:fill-[#F04A24]',
  LISTPAGE_BUTTON_LINK: 'text-[#F04A24]',
  LISTPAGE_ANCHOR_LINK: 'text-[#F04A24]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#F04A24]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#F04A24]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#F04A24]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#F04A24] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#F04A24] text-[#F04A24]  [&>svg>path]:stroke-[#F04A24] [&>svg>g>path]:stroke-[#F04A24] [&>svg>path]:fill-[#F04A24] [&>svg>g>path]:fill-[#F04A24]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#F04A24]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#F04A24]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#F04A24]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#F04A24]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'border-[#F04A24]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFD6B0] [&>.vector-top>path]:fill-[#FFAD62] [&>.vector-bottom>path]:fill-[#C88B53]',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#105924]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100 tablet:bg-[#E2E8F0]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#F7A491]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-black bg-[#F04A24]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#F04A24]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#FFEDD5] [&>circle]:stroke-[#FFEDD5] [&>path]:fill-[#FB923C]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container-new-layout',
}
